import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { useId } from 'react-id-generator';

// Own constants/actions/components
import { getPostalCodeAction } from 'services/actions/postal-code';
import { addNotesAction, useCrisDataAction } from 'services/actions/shopping-cart';

const ShippingInformation = (props) => {
  const {
    isGift,
    datas,
    personalData,
    addressData,
    register,
    errors,
    indexMap,
    setFocus,
    setValue,
    clearErrors,
  } = props;
  const idNameForm = 'exp-buy-pda-shp';
  const [idGen] = useId();
  const dispatch = useDispatch();
  const [isRequired, setIsRequired] = useState(true);
  const [typeAccount, setTypeAccount] = useState('PRINCIPAL');
  const [name, setName] = useState('');
  const [lastName, setLastname] = useState('');
  const [middleName, setMiddleName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [street, setStreet] = useState('');
  const [extNumber, setExtNumber] = useState('');
  const [intNumber, setIntNumber] = useState('');
  const [state, setState] = useState('');
  const [city, setCity] = useState('');
  const [colony, setColony] = useState([]);
  const [onlycolony, setOnlyColony] = useState('Colonia');
  const [municipality, setMunicipality] = useState('');
  const [colonyText, setColonyText] = useState([]);
  const [nameColonyText, setnameColonyText] = useState('colony-text');
  const [isRequiredColonyText, setIsRequiredColonyText] = useState(false);
  const [isRequiredExtNumber, setIsRequiredExtNumber] = useState(true);

  const handleChanged = (event) => {
    const selected = event.target.value;
    dispatch(useCrisDataAction(indexMap, isRequired));

    if (selected === 'true') {
      /* eslint-disable react/prop-types */
      const colonyAndMunicipality = addressData.colony.split(',');
      clearErrors();
      setColony([]);
      setName(personalData.name);
      setLastname(personalData.lastName);
      setMiddleName(personalData.middleName);
      setPhoneNumber(personalData.phoneNumber);
      setPostalCode(addressData.postalCode);
      setState(addressData.state);
      setCity(addressData.city);
      setOnlyColony([colonyAndMunicipality[0]]);
      setMunicipality(colonyAndMunicipality[1]);
      setStreet(addressData.street);
      setExtNumber(addressData.extNumber);
      setIntNumber(addressData.intNumber ? addressData.intNumber : '');
      setIsRequiredExtNumber(!addressData.extNumber.length);
      setTypeAccount('PRINCIPAL');

      setValue(`phoneNumber-${indexMap}`, personalData.phoneNumber, { shouldValidate: true });

      setIsRequired(false);
    } else if (selected === 'false') {
      setName('');
      setLastname('');
      setMiddleName('');
      setPhoneNumber('');
      setPostalCode('');
      setState('');
      setCity('');
      setOnlyColony('Colonia');
      setMunicipality('');
      setStreet('');
      setExtNumber('');
      setIntNumber('');
      setIsRequired(true);
      setTypeAccount('PRINCIPAL');
    }
  };

  const handleAddNotes = (event) => {
    dispatch(addNotesAction(indexMap, event.target.value));
  };

  const searchPostalCode = async (event) => {
    const cp = event.target.value;
    const cpNotFound = document.querySelectorAll('.cp-not-found')[0];

    if (!cp.length) {
      cpNotFound.classList.add('d-none');
    }

    if (cp.length === 5) {
      const response = await dispatch(getPostalCodeAction(cp));
      const {
        action: {
          payload: {
            data,
            status,
          },
        },
      } = response;

      if (status >= 200 && status < 300 && data.status !== false) {
        cpNotFound.classList.add('d-none');
        setState(data[0].state);
        setCity(data[0].town);
        const arrayColony = [];

        data.map((col) => {
          return arrayColony.push(col.colony);
        });
        setFocus(`state-${indexMap}`);
        setFocus(`city-${indexMap}`);
        setFocus(`colony-${indexMap}`);
        setFocus(`municipality-${indexMap}`);
        clearErrors(`state-${indexMap}`);
        clearErrors(`city-${indexMap}`);
        clearErrors(`colony-${indexMap}`);
        clearErrors(`municipality-${indexMap}`);
        setColony(arrayColony);
        setMunicipality(data[0].delegation);
      } else {
        cpNotFound.classList.remove('d-none');
      }
    }
  };

  const renderAddAddressNormal = () => {
    return (
      /* eslint-disable react/jsx-props-no-spreading */
      <Row className={idGen}>
        <Col lg={12}>
          <h2 className="text-tangaroa">Datos personales</h2>
          <h2 className="shipping-names-data">{!isRequired ? `${name} ${lastName} ${middleName}` : ''}</h2>
        </Col>
        <input
          {...register(`type-${indexMap}`)}
          name={`type-${indexMap}`}
          data-name="type"
          data-group={indexMap}
          hidden
          type="text"
          value={typeAccount}
          readOnly />
        <input type="text" hidden value={datas.id} data-name="idexp" data-group={indexMap} readOnly />
        <Col lg={6}>
          <div className="form-group pr-15">
            <label htmlFor={`${idNameForm}-inp-nam-ex${indexMap}`}>Nombre(s) de la persona que recibe</label>
            <input
              {...register(`name-${indexMap}`, {
                required: isRequired,
                pattern: /^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g,
                onChange: (e) => setName(e.target.value),
              })}
              id={`${idNameForm}-inp-nam-ex${indexMap}`}
              name={`name-${indexMap}`}
              data-name="name"
              data-group={indexMap}
              className="form-control shipping-name-data"
              placeholder="Nombre de la persona que recibe"
              type="text"
              value={name} />
            {errors[`name-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
            {errors[`name-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* No caracteres especiales</small>}
          </div>
        </Col>
        <Col lg={6}>
          <div className="form-group pr-15">
            <label htmlFor={`${idNameForm}-inp-las-nam-ex${indexMap}`}>Apellido Paterno</label>
            <input
              {...register(`lastName-${indexMap}`, {
                required: isRequired,
                pattern: /^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g,
                onChange: (e) => setLastname(e.target.value),
              })}
              id={`${idNameForm}-inp-las-nam-ex${indexMap}`}
              name={`lastName-${indexMap}`}
              data-name="lastName"
              data-group={indexMap}
              className="form-control shipping-lastname-data"
              placeholder="Apellido Paterno"
              type="text"
              value={lastName} />
            {errors[`lastName-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
            {errors[`lastName-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* No caracteres especiales</small>}
          </div>
        </Col>
        <Col lg={6}>
          <div className="form-group pr-15">
            <label htmlFor={`${idNameForm}-inp-mid-nam-ex${indexMap}`}>Apellido Materno</label>
            <input
              {...register(`middleName-${indexMap}`, {
                pattern: /^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g,
                onChange: (e) => setMiddleName(e.target.value),
              })}
              id={`${idNameForm}-inp-mid-nam-ex${indexMap}`}
              name={`middleName-${indexMap}`}
              data-name="middleName"
              data-group={indexMap}
              className="form-control shipping-middlename-data"
              placeholder="Apellido Materno"
              type="text"
              value={middleName} />
            {errors[`middleName-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* No caracteres especiales</small>}
          </div>
        </Col>
        <Col lg={12}>
          <h2 className="mt-15">{!isRequired ? '' : 'Nueva dirección'}</h2>
        </Col>
        <Col lg={6}>
          <div className="form-group pr-15">
            <label htmlFor={`${idNameForm}-inp-cpx-ex${indexMap}`}>Código postal</label>
            <input
              {...register(`cp-${indexMap}`, {
                required: isRequired,
                onChange: (e) => {
                  setIsRequired(true);
                  if (e.target.value.length <= 5) {
                    setPostalCode(e.target.value);
                  } else {
                    e.preventDefault();
                  }
                },
              })}
              id={`${idNameForm}-inp-cpx-ex${indexMap}`}
              name={`cp-${indexMap}`}
              data-name="cp"
              data-group={indexMap}
              data-address={indexMap}
              className="form-control shipping-postalCode-data"
              placeholder="Código postal"
              type="number"
              value={postalCode}
              onKeyUp={searchPostalCode} />
            {errors[`cp-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
            <small className="error-msg d-none cp-not-found">* El código postal no se encuentra registrado</small>
          </div>
        </Col>
        <Col lg={6}>
          <div className="form-group pr-15">
            <label htmlFor={`${idNameForm}-inp-sta-ex${indexMap}`}>Estado</label>
            <input
              {...register(`state-${indexMap}`, {
                required: isRequired,
                pattern: /^[a-zA-Z0-9 . *(a-zA-ZÀ-ÖØ-öø-ÿ*)*]+$/,
                onChange: (e) => setState(e.target.value),
              })}
              id={`${idNameForm}-inp-sta-ex${indexMap}`}
              name={`state-${indexMap}`}
              data-name="state"
              data-group={indexMap}
              data-address={indexMap}
              className="form-control shipping-state-data"
              placeholder="Estado"
              type="text"
              value={state} />
            {errors[`state-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
            {errors[`state-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* No caracteres especiales</small>}
          </div>
        </Col>
        <Col lg={6}>
          <div className="form-group pr-15">
            <label htmlFor={`${idNameForm}-inp-cit-ex${indexMap}`}>Ciudad</label>
            <input
              {...register(`city-${indexMap}`, {
                required: isRequired,
                pattern: /^[a-zA-Z0-9 . *(a-zA-ZÀ-ÖØ-öø-ÿ*)*]+$/,
                onChange: (e) => setCity(e.target.value),
              })}
              id={`${idNameForm}-inp-cit-ex${indexMap}`}
              name={`city-${indexMap}`}
              data-name="city"
              data-group={indexMap}
              data-address={indexMap}
              className="form-control shipping-city-data"
              placeholder="Ciudad"
              type="text"
              value={city} />
            {errors[`city-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
            {errors[`city-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* No caracteres especiales</small>}
          </div>
        </Col>
        <Col lg={6}>
          <div className="form-group pr-15">
            <label htmlFor={`${idNameForm}-inp-mun-ex${indexMap}`}>Municipio o Delegación</label>
            <input
              {...register(`municipality-${indexMap}`, {
                required: isRequired,
                pattern: /^[a-zA-Z0-9 . *(a-zA-ZÀ-ÖØ-öø-ÿ*)*]+$/,
                onChange: (e) => setMunicipality(e.target.value),
              })}
              id={`${idNameForm}-inp-mun-ex${indexMap}`}
              name={`municipality-${indexMap}`}
              data-name="municipality"
              data-group={indexMap}
              data-address={indexMap}
              className="form-control shipping-municipality-data"
              placeholder="Municipio o Delegación"
              type="text"
              value={municipality} />
            {errors[`municipality-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
            {errors[`municipality-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* No caracteres especiales</small>}
          </div>
        </Col>
        <Col lg={6}>
          <div className="form-group pr-15">
            <label htmlFor={`${idNameForm}-inp-col-ex${indexMap}`}>Colonia</label>
            <div className="custom-select-cp">
              <select
                {...register(`colony-${indexMap}`, {
                  required: isRequired,
                  onChange: (e) => {
                    if (e.target.value === 'otra') {
                      setnameColonyText('colony');
                      setIsRequiredColonyText(true);
                    } else {
                      setnameColonyText('colony-text');
                      setIsRequiredColonyText(false);
                    }
                  },
                })}
                id={`${idNameForm}-inp-col-ex${indexMap}`}
                name={`colony-${indexMap}`}
                data-name="colony"
                data-group={indexMap}
                data-address={indexMap}
                className="custom-select shipping-colony-data"
                defaultValue="DEFAULT">
                {
                  isRequired ? (
                    <option value="" defaultValue>Colonia</option>
                  ) : <option value={onlycolony} defaultValue>{onlycolony}</option>
                }
                {
                  /* eslint-disable */
                  colony.map((col, index) => <option value={col} key={index}>{col}</option>)
                }
                <option value="otra">Otra</option>
              </select>
            </div>
            {errors[`colony-${indexMap}`] && <small className="error-msg">* Campo requerido</small>}
          </div>
        </Col>
        <Col lg={6} className={isRequiredColonyText ? '' : 'd-none'}>
          <div className="form-group pr-15">
            <label htmlFor={`${idNameForm}-inp-col-inp-ex${indexMap}`}>Ingresa la Colonia</label>
            <input
              {...register(`colony-input-${indexMap}`, {
                required: isRequiredColonyText,
                pattern: /^[a-zA-Z0-9 . *(a-zA-ZÀ-ÖØ-öø-ÿ*)*]+$/,
                onChange: (e) => setColonyText(e.target.value),
              })}
              id={`${idNameForm}-inp-col-inp-ex${indexMap}`}
              name={`colony-input-${indexMap}`}
              data-name={nameColonyText}
              data-group={indexMap}
              data-address={indexMap}
              className="form-control shipping-colony-input-data"
              placeholder="Ingresa la Colonia"
              type="text"
              value={colonyText} />
            {errors[`colony-input-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
            {errors[`colony-input-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* No caracteres especiales</small>}
          </div>
        </Col>
        <Col lg={6}>
          <div className="form-group pr-15">
            <label htmlFor={`${idNameForm}-inp-add-ex${indexMap}`}>Calle</label>
            <input
              {...register(`street-${indexMap}`, {
                required: isRequired,
                pattern: /^[a-zA-Z0-9 . *(a-zA-ZÀ-ÖØ-öø-ÿ*)*]+$/,
                onChange: (e) => setStreet(e.target.value),
              })}
              id={`${idNameForm}-inp-add-ex${indexMap}`}
              name={`street-${indexMap}`}
              data-name="street"
              data-group={indexMap}
              data-address={indexMap}
              className="form-control shipping-street-data"
              placeholder="Calle"
              type="text"
              value={street} />
            {errors[`street-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
            {errors[`street-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* No caracteres especiales</small>}
          </div>
        </Col>
        <Col lg={6}>
          <div className="form-group pr-15">
            <label htmlFor={`${idNameForm}-inp-num-ext-ex${indexMap}`}>No. Exterior</label>
            <input
              {...register(`extNumber-${indexMap}`, {
                required: isRequiredExtNumber,
                pattern: /^[a-zA-Z\-0-9]+$/,
                onChange: (e) => setExtNumber(e.target.value),
              })}
              id={`${idNameForm}-inp-num-ext-ex${indexMap}`}
              name={`extNumber-${indexMap}`}
              data-name="extNumber"
              data-group={indexMap}
              data-address={indexMap}
              className="form-control shipping-extNumber-data"
              placeholder="No. Exterior"
              type="text"
              value={extNumber} />
            {errors[`extNumber-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
            {errors[`extNumber-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* No caracteres especiales</small>}
          </div>
        </Col>
        <Col lg={6}>
          <div className="form-group pr-15">
            <label htmlFor={`${idNameForm}-inp-num-int-ex${indexMap}`}>No. Interior</label>
            <input
              {...register(`intNumber-${indexMap}`, {
                pattern: /^[a-zA-Z\-0-9]+$/,
                onChange: (e) => setIntNumber(e.target.value),
              })}
              id={`${idNameForm}-inp-num-int-ex${indexMap}`}
              name={`intNumber-${indexMap}`}
              data-name="intNumber"
              data-group={indexMap}
              data-address={indexMap}
              className="form-control shipping-intNumber-data"
              placeholder="No. Interior"
              type="text"
              value={intNumber} />
              {errors[`intNumber-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* No caracteres especiales</small>}
          </div>
        </Col>
        <Col lg={6}>
          <div className="form-group pr-15">
            <label htmlFor={`${idNameForm}-inp-pho-ex${indexMap}`}>Teléfono celular</label>
            <input
              {...register(`phoneNumber-${indexMap}`, {
                required: isRequired,
                validate: {
                  number: (value) => /^[0-9]{10}$/.test(value),
                  startedZero: (value) => /^[1-9a-zA-Z][0-9a-zA-Z]*$/.test(value),
                },
                onChange: (e) => setPhoneNumber(e.target.value),
              })}
              id={`${idNameForm}-inp-pho-ex${indexMap}`}
              name={`phoneNumber-${indexMap}`}
              data-name="phoneNumber"
              data-group={indexMap}
              className="form-control shipping-phoneNumber-data"
              placeholder="Teléfono celular"
              type="text"
              value={phoneNumber} />
            {errors[`phoneNumber-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
            {errors[`phoneNumber-${indexMap}`]?.type === 'number' && <small className="error-msg">* Solo 10 dígitos</small>}
            {errors[`phoneNumber-${indexMap}`]?.type === 'startedZero' && <small className="error-msg">* No debe comenzar con 0</small>}
          </div>
        </Col>
      </Row>
    );
  };

  return (
    <>
      <div className="shopping-card-info shipping-information my-30" data-id={datas.id}>
        <Row>
          <Col lg={4}>
            <img
              src={datas.image}
              alt="card-exp"
              className="w-100 p-15" />
          </Col>
          <Col lg={8} className="text-left px-30 px-lg-15">
            <h3 className="py-15">{datas.title}</h3>
            <div className="custom-control custom-radio">
              <input
                id={`${idNameForm}-rdi-use-fom-${idGen}`}
                type="radio"
                name={`useCrisData-${indexMap}`}
                data-name="useCrisData"
                data-group={indexMap}
                className="custom-control-input"
                value={true}
                checked={!isRequired}
                onChange={handleChanged} />
              <label className="custom-control-label" htmlFor={`${idNameForm}-rdi-use-fom-${idGen}`}>
                Utilizar los datos registrados en Aeroméxico Rewards
              </label>
            </div>
            <div className="custom-control custom-radio">
              <input
                id={`${idNameForm}-rdi-add-fom-${idGen}`}
                type="radio"
                name={`useCrisData-${indexMap}`}
                data-name="useCrisData"
                data-group={indexMap}
                className="custom-control-input check-b"
                value={false}
                checked={isRequired}
                onChange={handleChanged} />
              <label className="custom-control-label" htmlFor={`${idNameForm}-rdi-add-fom-${idGen}`}>
                Agregar una dirección
              </label>
            </div>
            <div className={`add-form-container-${idGen}`}>
              { renderAddAddressNormal() }
            </div>
            {
              isGift === true
                ? (
                  <div className="custom-control custom-control-area custom-input-area">
                    <label htmlFor="notes">Escribe una nota</label>
                    <textarea
                      id={`${idNameForm}-txa-add-fom-${idGen}`}
                      data-key={indexMap}
                      name="notes"
                      rows="4"
                      placeholder="Agrega un mensaje (opcional)"
                      onChange={handleAddNotes} />
                  </div>
                ) : ''
            }
          </Col>
          {
            isGift === true
              ? (
                <Col lg={12}>
                  <div className="text-left gift-label">
                    <i className="fas fa-gift mr-2 text-white" />
                    <span>Esta Experiencia es un regalo</span>
                  </div>
                </Col>
              ) : ''
          }
          {
            datas.stock !== null && datas.stock < 5 ? (
              <Col lg={12}>
                <div className="text-left stock-label">
                  <i className="fas fa-exclamation-triangle mr-2" />
                  <span>Quedan muy pocas Experiencias. ¡Date prisa!</span>
                </div>
              </Col>
            ) : ''
          }
        </Row>
      </div>
    </>
  );
};

ShippingInformation.propTypes = {
  isGift: PropTypes.bool.isRequired,
  datas: PropTypes.object.isRequired,
  personalData: PropTypes.object,
  addressData: PropTypes.object.isRequired,
  register: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  indexMap: PropTypes.number.isRequired,
  setFocus: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
};

export default ShippingInformation;
